import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import FlexView from "react-flexview";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {contructQueryParam, fetchDataAsync, hasNilOrEmpty} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import * as R from "ramda";
import {mapToObjectDDL} from "../../../../common/mapper";
import {HttpStatus} from "../../../../common/Constants";
import { defaultTableChange } from "../../../../../modules/custom/customTable";
import { fetchAvailableSalesOrderUnits } from "./unitAvailability";
import { getOldestUnit } from "./violationRules";

class FakturJualDetailDataInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchKey: null,
            searchValue: null,
            tableColumns: [...this.getTableColumns()],
            dataTable: [],
            oldestUnit: {},
            rollBackDataTable: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        const {type} = this.props;
        const dataTable = await this.fetchData(type);
        this.setState((prevState) => ({
            ...prevState,
            dataTable: !R.isEmpty(dataTable) ? dataTable : [],
            rollBackDataTable: !R.isEmpty(dataTable) ? dataTable : [],
        }));

        this.handleTriggerLoading();
    }

    getTableColumns() {
        let columns = [...this.props.tableColumns];
        columns.push({
            name: "action",
            label: "Aksi",
            options: {
                customBodyRender: (_, tableMeta) => (
                    <FlexView hAlignContent="center" style={{gap: 10}}>
                        <SimpleButton
                            type="button"
                            text="Pilih"
                            onClick={() => this.handleSelect(tableMeta.rowIndex)}
                        />
                    </FlexView>
                ),
                sort: false
            },
        })

        return columns;
    }

    handleSearchValueChange = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        let {searchKey, searchValue, rollBackDataTable} = this.state;
        let isRollBack = hasNilOrEmpty(searchValue);
        const {type} = this.props;
        let filteredDataTable = [];
        if (type === "NokaNosin") {
            filteredDataTable = !isRollBack
                ? await this.fetchData(type, {[searchKey?.value]: searchValue.toString()})
                : rollBackDataTable;
        } else {
            this.setState({
                    pagination: {
                    count: 10,
                    limit: 5,
                    page: 1,
                    orderBy: "id",
                    sort: "ASC",
                },
            });
            filteredDataTable = !isRollBack
                ? await this.fetchData(type, {[searchKey?.value]: searchValue?.toString()})
                : rollBackDataTable;
        }
        this.handleTriggerLoading();
        this.setState((prevState) => ({
            ...prevState,
            dataTable: filteredDataTable
        }))
    };

    handleSelect = (rowIndex) => {
        this.props.onSelect(this.state.dataTable[rowIndex], this.props.type, this.state.oldestUnit);
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (type, reqBody = {}) => {
        let dataTable = [];
        let req;
        let res;

        switch (type) {
            case "Customer":
                res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_TRANSACTION").getListCustomerForSalesOrder,
                    setError: this.props.setError,
                    menuName: "Faktur Jual - Data Unit",
                    args: contructQueryParam({
                        customerName: this.state.searchValue || "",
                        ...(reqBody.limit ? {limit: reqBody.limit} : {limit: 5}),
                        ...(reqBody.page ? {page: reqBody.page} : {page: 1})
                    }),
                })

                this.setState(prev=>({
                    ...prev,
                    pagination:{
                        ...prev.pagination,
                        count: res.data.totalData || 0,
                    }
                }))

                dataTable = R.isEmpty(res.data.data) ? [] : res.data.data?.map(item => {
                    return {
                        name: item?.name,
                        hpNumber1: item?.noTelepon,
                        hpNumber2: item?.noTelepon2,
                        nik: item?.nik,
                        tanggalLahir: item?.tanggalLahir,
                        email: item?.email,
                        npwp: item?.npwp,
                        address: item?.alamat,
                        kkNumber: item?.kkNumber,
                        province: mapToObjectDDL(item?.dataProvince?.provinceName, item?.dataProvince?.id),
                        kabkot: mapToObjectDDL(item?.dataKabKot?.kabKotName, item?.dataKabKot?.kabKotId),
                        kecamatan: mapToObjectDDL(item?.dataKecamatan?.kecamatanName, item?.dataKecamatan?.id),
                        kelurahan: mapToObjectDDL(item?.dataKelurahan?.kelurahanname, item?.dataKelurahan?.id),
                        zipCode: mapToObjectDDL(item?.dataKelurahan?.zipcode, item?.dataKelurahan?.zipcode),
                        gender: mapToObjectDDL(item?.gender?.value, item?.gender?.key),
                        job1: mapToObjectDDL(item?.job1?.value, item?.job1?.key),
                        job2: mapToObjectDDL(item?.job2?.value, item?.job2?.key),
                        religion: mapToObjectDDL(item?.religion?.value, item?.religion?.key),
                        memberId: item?.memberId,
                        memberLevel: item?.memberLevel,
                        loyaltyLevel: item?.loyaltyLevel,
                        facebook: item?.facebook,
                        instagram: item?.instagram,
                        linkedin: item?.linkedin,
                        x: item?.x,
                        tiktok: item?.tiktok,
                        hobby: mapToObjectDDL(item?.hobby?.[0]?.value, item?.hobby?.[0]?.key),
                        interest: mapToObjectDDL(item?.interest?.[0]?.value, item?.interest?.[0]?.key),
                    }
                });
                break;
            case "NokaNosin":
                req = {
                    kodeCabang: this.props.data.kodeCabang?.value,
                    kodeVariant: this.props.data.dataUnit?.["kodeVariant"]?.label,
                    idWarna: this.props.data.dataUnit?.["idWarna"]?.value,
                    ...(Object.keys(reqBody).length > 0 ? reqBody : {nomorRangka: ""})
                };

                const unitList = await fetchAvailableSalesOrderUnits({
                    ...req,
                    setError: this.props.setError,
                });
                const oldestUnit = getOldestUnit(unitList);

                this.setState((prevState) => ({
                    ...prevState,
                    oldestUnit: oldestUnit
                }))

                dataTable = R.isEmpty(unitList) ? [] : unitList.map(item => {
                    return {
                        kodeVariant: item.variant?.kodeVariant,
                        namaVariant: item.variant?.namaVariant,
                        idType: item.variant?.idType,
                        kodeWarna: item.warna?.kodeWarna,
                        idWarna: item.warna?.id,
                        namaWarnaKomersil: item.warna?.namaWarnaKomersil,
                        nomorMesin: item.nosin,
                        nomorRangka: item.noka,
                        locator: item.dataLocation?.nameLocation,
                        usia: item.umur
                    }
                });
                break;

            case "Indent":
                res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_TRANSACTION").getIndentForSalesOrder,
                    setError: this.props.setError,
                    menuName: "Faktur Jual - Data Unit",
                    args: contructQueryParam({
                        kodeCabang: this.props.state.kodeCabang?.value,
                        ...(this.state.searchValue ? {namaCustomer: this.state.searchValue} : {})
                    }),
                })

                if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                    dataTable = R.isEmpty(res.data.data) ? [] : res.data.data.map(item => {
                        return {
                            indentNo: item.indentNo,
                            sellerName: item.sellerName,
                            name: item.customerName,
                            hpNumber1: item.customerHpNumber,
                            address: item.customerAddress,
                            provinceId: mapToObjectDDL(item.dataProvinceCustomer?.provinceName, item.dataProvinceCustomer?.id),
                            kecamatanId: mapToObjectDDL(item.dataKecamatanCustomer?.kecamatanName, item.dataKecamatanCustomer?.id),
                            kelurahanId: mapToObjectDDL(item.dataKelurahanCustomer?.kelurahanname, item.dataKelurahanCustomer?.id),
                            prospectId: item.prospectId
                        }
                    });
                }
                break;
            case "Prospek":
                res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_TRANSACTION").getProspectForSalesOrder,
                    setError: this.props.setError,
                    menuName: "Faktur Jual - Data Unit",
                    args: contructQueryParam({
                        kodeCabang: this.props.state.kodeCabang?.value,
                        ...(this.state.searchValue ? {customerName: this.state.searchValue} : {})
                    }),
                })

                if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                    dataTable = R.isEmpty(res.data.data) ? [] : res.data.data.map(item => {
                        return {
                            prospectNo: item.nomorProspek,
                            pemilikProspek: item.pemilikProspek,
                            jenisProspect: item.jenisProspek,
                            name: item.nama,
                            hpNumber1: item.telepon,
                            address: item.alamat,
                            provinceId: mapToObjectDDL(item.provinsi?.provinceName, item.provinsi?.id),
                            kecamatanId: mapToObjectDDL(item.kecamatan?.kecamatanName, item.kecamatan?.id),
                            kelurahanId: mapToObjectDDL(item.kelurahan?.kelurahanname, item.kelurahan?.id),
                        }
                    });
                }
                break;
            default:
                break;
        }

        return dataTable;
    }

    handleChangePage = async (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: tableState.page + 1,
        },
      }));

      this.handleTriggerLoading();
        let {searchKey, searchValue} = this.state;
        const {type} = this.props;
        const data = await this.fetchData(type, {
            [searchKey?.value]: searchValue?.toString(),
            limit: this.state.pagination.limit,
            page: tableState.page + 1,
        })

        this.setState((prevState) => ({
            ...prevState,
            dataTable: data
        }))
        this.handleTriggerLoading();
    };

    handleRowsPerPage = async (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          page: 1,
          totalData: 1,
          limit: tableState.rowsPerPage,
        },
      }));
       this.handleTriggerLoading();
        let {searchKey, searchValue} = this.state;
        const {type} = this.props;
        const data = await this.fetchData(type, {
            [searchKey?.value]: searchValue?.toString(),
            page: this.state.pagination.page,
            limit: tableState.rowsPerPage,
        })

        this.setState((prevState) => ({
            ...prevState,
            dataTable: data
        }))
        this.handleTriggerLoading();
    };

    render() {
        return (
            <>
                <SimpleModal
                    title={this.props.title}
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            {this.props.type === "NokaNosin" ? (
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <p className="margin-bottom-20px">Pilih: </p>
                                    <SimpleDDL
                                        id="select_options_search"
                                        box="search"
                                        name="searchKey"
                                        containerclassname="width width-250px"
                                        menuPosition="fixed"
                                        placeholder="NOKA / NOSIN"
                                        options={[
                                            {label: "NOKA", value: "nomorRangka"},
                                            {label: "NOSIN", value: "nomorMesin"},
                                        ]}
                                        isClearable
                                        value={this.state.searchKey}
                                        onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                                    />
                                    <p className="margin-bottom-20px">Cari: </p>
                                    <SimpleInput
                                        type="text"
                                        name="searchValue"
                                        value={this.state.searchValue}
                                        onChange={(e) => this.handleSearchValueChange(e.target.name, e.target.value)}
                                    />
                                    <SimpleButton
                                        text="Cari"
                                        className="margin-bottom-15px"
                                        onClick={this.handleSubmitSearch}
                                    />
                                </FlexView>
                            ) : (
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <p className="margin-bottom-20px">Nama {this.props.type}: </p>
                                    <SimpleInput
                                        type="text"
                                        name="searchValue"
                                        value={this.state.searchValue}
                                        onChange={(e) => this.handleSearchValueChange(e.target.name, e.target.value)}
                                    />
                                    <SimpleButton
                                        text="Cari"
                                        className="margin-bottom-15px"
                                        onClick={this.handleSubmitSearch}
                                    />
                                </FlexView>
                            )}

                            {this.props.type === "Customer" ? 
                                <SimpleDataTable
                                    data={this.state.dataTable}
                                    columns={this.state.tableColumns}
                                    toCount={this.state.pagination.count}
                                    rowsPerPage={this.state.pagination.limit}
                                    page={this.state.pagination.page - 1}
                                    options={defaultTableChange(
                                      this.handleChangePage,
                                      this.handleRowsPerPage
                                    )}
                                />   
                            :
                                <SimpleDataTable
                                    data={this.state.dataTable}
                                    columns={this.state.tableColumns}
                                    toCount={this.state.dataTable.length}
                                    rowsPerPage={5}
                                    page={0}
                                    options={{serverSide: false}}
                                />
                            }
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(FakturJualDetailDataInput);
